<template>
  <BrandTheme :theme="theme">
    <FadeTransition>
      <div>
        <div class="m-0 flow-root">
          <!-- START HEADER -->
          <div id="hero" class="mt-9" />
          <!-- END HEADER -->
          <div v-if="useShow === 'image'" class="pt-14">
            <div class="relative h-[2008px] w-[3840px] overflow-hidden">
              <img
                :src="
                  'https://contenthub.accadis-bildung.de/assets/' +
                  image +
                  '?fit=cover&width=3840&height=2008'
                "
                class="absolute inset-0 size-full object-contain"
                alt=""
              />
              <div class="relative p-4">
                <div v-html="content" />
              </div>
            </div>
          </div>

          <div v-if="useShow === 'ytvideo'" class="pt-14">
            <iframe
              width="3840"
              height="2008"
              :src="
                'https://www.youtube.com/embed/' +
                yturl +
                '?version=3&loop=1&autoplay=1&controls=0&mute=1&showinfo=0&modestbranding=0&rel=0&playlist=' +
                yturl
              "
              title="YouTube video player"
              frameborder="0"
              allow="
                accelerometer;
                autoplay;
                clipboard-write;
                encrypted-media;
                gyroscope;
                picture-in-picture;
                web-share;
              "
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            />
          </div>
        </div>
      </div>
    </FadeTransition>
  </BrandTheme>
</template>

<script lang="ts" setup>
const props = defineProps({
  theme: { type: String, required: true },
  image: { type: String, required: true },
  yturl: { type: String, required: true },
  useShow: { type: String, required: true },
  content: { type: String, required: false },
});

const image = computed(() => props.image);
const yturl = computed(() => props.yturl);
const content = computed(() => props.content);
const useShow = computed(() => props.useShow);
const theme = computed(() => props.theme);
</script>
